import React from 'react';
import classnames from 'classnames';
import { withTranslation, WithTranslation } from 'react-i18next';
import { ModuleType } from '../../../../../types/modules';
import { ZoneType } from '../../../../../types/layout';

import s from './WidgetTypeCard.scss';

export interface Props {
  zone: ZoneType;
  moduleType: ModuleType;
  className?: string;
}

export class WidgetTypeCard extends React.Component<Props & WithTranslation> {
  render() {
    const { zone, moduleType, className, t } = this.props;

    let title;
    let description;
    let miniatureClassname;

    switch (moduleType) {
      case ModuleType.EXHIBITIONIST:
        if (zone === ZoneType.TOP_BAR) {
          title = t('widgets.exhibitionist.scroller.addButtonHeader');
          description = t('widgets.exhibitionist.scroller.description');
          miniatureClassname = 'exhibitionist-slider';
        } else {
          title = t('widgets.exhibitionist.gridGallery.addButtonHeader');
          description = t('widgets.exhibitionist.gridGallery.description');
          miniatureClassname = 'exhibitionist-grid';
        }
        break;
      case ModuleType.WATCHERS:
        title = t('widgets.watchers.addButtonHeader');
        description = t('widgets.watchers.description');
        miniatureClassname = 'watchers';
        break;
      case ModuleType.WATCHING:
        title = t('widgets.watching.addButtonHeader');
        description = t('widgets.watching.description');
        miniatureClassname = 'watching';
        break;
      case ModuleType.GROUPS_MEMBER:
        title = t('widgets.groups_member.addButtonHeader');
        description = t('widgets.groups_member.description');
        miniatureClassname = 'groups-member';
        break;
      case ModuleType.GROUPS_ADMIN:
        title = t('widgets.groups_admin.addButtonHeader');
        description = t('widgets.groups_admin.description');
        miniatureClassname = 'groups-admin';
        break;
      case ModuleType.DONATIONS:
        title = t('widgets.donations.addButtonHeader');
        description = t('widgets.donations.description');
        miniatureClassname = 'donations';
        break;
      case ModuleType.DEVIOUSNESS:
        title = t('widgets.deviousness.addButtonHeader');
        description = t('widgets.deviousness.description');
        miniatureClassname = 'deviousness';
        break;
      case ModuleType.FEED:
        title = t('widgets.feed.addButtonHeader');
        description = t('widgets.feed.description');
        miniatureClassname = 'feed';
        break;
      case ModuleType.MY_COMMENTS:
        title = t('widgets.myComments.addButtonHeader');
        description = t('widgets.myComments.description');
        miniatureClassname = 'my-comments';
        break;
      case ModuleType.COMMENTS:
        title = t('widgets.profileComments.addButtonHeader');
        description = t('widgets.profileComments.description');
        miniatureClassname = 'profile-comments';
        break;
      case ModuleType.BADGES_ACTIVITY:
        title = t('widgets.myBadges.addButtonHeader');
        description = t('widgets.myBadges.description');
        miniatureClassname = 'my-badges';
        break;
      case ModuleType.STATS:
        title = t('widgets.statistics.addButtonHeader');
        description = t('widgets.statistics.description');
        miniatureClassname = 'stats';
        break;
      case ModuleType.VISITORS:
        title = t('widgets.visitors.addButtonHeader');
        description = t('widgets.visitors.description');
        miniatureClassname = 'visitors';
        break;
      case ModuleType.FEATURED_DEVIATION:
        title = t('widgets.featured_deviation.addButtonHeader');
        description = t('widgets.featured_deviation.description');
        miniatureClassname = 'featured-deviation';
        break;
      case ModuleType.CUSTOM:
        title = t!('widgets.custombox.addButtonHeader');
        description = t!('widgets.custombox.description');
        miniatureClassname = 'custombox';
        break;
      default:
        title = moduleType;
        description = 'no widget type card';
    }

    return (
      <div className={classnames(s['root'], className)}>
        <div
          className={classnames(
            s['miniature'],
            s[`miniature-${miniatureClassname}`]
          )}
        />
        <div className={s['title']}>{title}</div>
        <div className={s['description']}>{description}</div>
      </div>
    );
  }
}

export default withTranslation()(WidgetTypeCard);
